import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { HTTPService, HelperService } from 'app/services';
import { debounce } from 'lodash';

@Component({
  selector: 'app-authorization-tire-dot-number',
  templateUrl: './authorization-tire-dot-number.component.html',
  styleUrls: ['./authorization-tire-dot-number.component.scss'],
})
export class AuthorizationTireDotNumberComponent implements OnInit {
  @Input() dotNumberServices: any[] = [];
  @Input() isArchived: boolean = false;
  @Input() estimateId: string = '';
  @Input() isFinalizedRo: boolean = false;

  @Output() evaluateTireDotNumber = new EventEmitter<any>();
  saveTireDotNumbers = debounce(this._saveTireDotNumbers, 600);

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService,
  ) {}

  ngOnInit(): void {}

  handleChange(value: any, dotNumberItem: any, serviceId: string, serviceItem: any) {
    if (this.isFinalizedRo) return;
    if (!value) {
      dotNumberItem.tirePosition = '';
      dotNumberItem.tooltip = 'Please enter DOT# to specify tire position';
    } else {
      dotNumberItem.tooltip = '';
    }
    dotNumberItem.dotNumber = value;
    if (serviceItem?.flatRateAmount) {
      const service = this.dotNumberServices.find((service) => service._id === serviceId);
      const targetItem = this.findParentItemId(service, serviceItem);
      this.saveTireDotNumbers({ orderId: this.estimateId, serviceId, tireId: serviceItem?._id, dotNumbers: serviceItem?.dotNumbers, parentItemId: targetItem });
    } else {
      this.saveTireDotNumbers({ orderId: this.estimateId, serviceId, tireId: serviceItem?._id, dotNumbers: serviceItem?.dotNumbers });
    }
  }

  onCardTypeSelect(tirePosition: any, dotNumberItem: any, serviceId: string, serviceItem: any) {
    if (this.isFinalizedRo) return;
    if (dotNumberItem?.tirePosition === tirePosition?.value) {
      dotNumberItem.tirePosition = '';
      dotNumberItem.tooltip = 'Please enter DOT# to specify tire position';
    } else {
      dotNumberItem.tirePosition = tirePosition?.value;
      dotNumberItem.tooltip = '';
    }
    if (serviceItem?.flatRateAmount) {
      const service = this.dotNumberServices.find((service) => service._id === serviceId);
      const targetItem = this.findParentItemId(service, serviceItem);
      this.saveTireDotNumbers({ orderId: this.estimateId, serviceId, tireId: serviceItem?._id, dotNumbers: serviceItem?.dotNumbers, parentItemId: targetItem });
    } else {
      this.saveTireDotNumbers({ orderId: this.estimateId, serviceId, tireId: serviceItem?._id, dotNumbers: serviceItem?.dotNumbers });
    }
  }

  async _saveTireDotNumbers(data: any) {
    if (!this.estimateId) {
      return;
    }
    try {
      const response = await this.httpService.updateTireDotNumber(data);
      this.evaluateTireDotNumber.emit(this.helperService.deepCopy(this.dotNumberServices));
    } catch (error) {
      this.helperService.showToaster('error', error);
    }
  }

  findParentItemId(service: any, serviceItem: any) {
    return service?.items?.reduce((acc, item) => {
      if (item?.subItems?.length) {
        const doesTargetItemExists = item.subItems?.some((subItem) => subItem._id === serviceItem._id);
        if (doesTargetItemExists && !acc) {
          acc = item._id;
        }
      }
      return acc;
    }, '');
  }
}
